// @flow

/**
 * Export `zIndex`.
 */

export const zIndex = {
  announcementBar: 10
};
